
import { mapState, mapGetters } from 'vuex'
export default {
    name: 'Theme3MobileMyProfile',
    data() {
        return {
            social_info: [
                {
                    id: null,
                    social_media_type: null,
                    social_media_id: '',
                },
            ],
            formData: {
                phone: null,
                social_info: [
                    {
                        id: null,
                        social_media_type: null,
                        social_media_id: '',
                    },
                ],
            },
            editNickname: false,
            nickname: '',
        }
    },
    computed: {
        ...mapState({
            player: (state) => state.player.player,
        }),
        ...mapGetters({
            loading: 'themes/player/loading',
        }),
        platforms() {
            return [
                {
                    val: null,
                    text: this.tl('none'),
                },
                {
                    val: 1,
                    text: 'Telegram',
                },
                {
                    val: 2,
                    text: 'Zalo ID',
                },
                {
                    val: 3,
                    text: 'Line',
                },
                {
                    val: 4,
                    text: 'Facebook',
                },
                {
                    val: 5,
                    text: 'Whatsapp',
                },
                {
                    val: 6,
                    text: 'WecChat',
                },
            ]
        },
    },
    watch: {
        player(value) {
            this.formData.phone = value.phone
            if (value && value.social_info) {
                if (value.social_info.length > 0) {
                    const social = JSON.parse(JSON.stringify(value.social_info))
                    this.social_info = social
                }
            }
        },
    },
    mounted() {
        // setting default values into the form
        if (this.player) {
            const value = this.player
            this.formData.phone = value?.phone
            if (value && value?.social_info) {
                if (value?.social_info?.length > 0) {
                    try {
                        const social = JSON.parse(
                            JSON.stringify(value.social_info)
                        )
                        this.social_info = social
                    } catch (error) {}
                }
            }
        }
    },
    methods: {
        updateProfile() {
            this.formData.social_info = this.social_info
            this.$store.dispatch('themes/player/doUpdatePlayerProfile', {
                ...this.formData,
            })
        },
        showEditNickname() {
            this.nickname = this.player.nickname
            this.editNickname = !this.editNickname
        },
        updateNickname() {
            if (this.nickname && this.nickname !== this.player.nickname) {
                this.$store.dispatch('themes/player/doUpdatePlayerProfile', {
                    nickname: this.nickname,
                })
            }
            this.editNickname = false
        },
    },
}
